export const militaryBranches = [
  'Army',
  'Navy',
  'Air Force',
  'Marines',
  'Coast Guard'
];

export const militaryStatus = [
  'Active',
  'Inactive',
  'Retired',
  'Veteran',
  'Other'
];

export const passwordRegex = /^(?=.*[A-Z])(?=.*[\W_]).{8,16}$/;

export const stateNameToAbbr = {
  Alabama: "AL", Alaska: "AK", Arizona: "AZ", Arkansas: "AR", California: "CA",
  Colorado: "CO", Connecticut: "CT", Delaware: "DE", Florida: "FL", Georgia: "GA",
  Hawaii: "HI", Idaho: "ID", Illinois: "IL", Indiana: "IN", Iowa: "IA", Kansas: "KS",
  Kentucky: "KY", Louisiana: "LA", Maine: "ME", Maryland: "MD", Massachusetts: "MA",
  Michigan: "MI", Minnesota: "MN", Mississippi: "MS", Missouri: "MO", Montana: "MT",
  Nebraska: "NE", Nevada: "NV", "New Hampshire": "NH", "New Jersey": "NJ", "New Mexico": "NM",
  "New York": "NY", "North Carolina": "NC", "North Dakota": "ND", Ohio: "OH", Oklahoma: "OK",
  Oregon: "OR", Pennsylvania: "PA", "Rhode Island": "RI", "South Carolina": "SC",
  "South Dakota": "SD", Tennessee: "TN", Texas: "TX", Utah: "UT", Vermont: "VT",
  Virginia: "VA", Washington: "WA", "West Virginia": "WV", Wisconsin: "WI", Wyoming: "WY",
  "District of Columbia": "DC",
};

export const payTypes = [
  "Hourly",
  "Salary",
  "Contract",
  "Commission",
  "Internship"
];


export const employmentTypes = [
  "Full-Time",
  "Part-Time",
  "Contract",
  "Temporary",
  "Internship",
  "Seasonal",
  "Freelance",
  "Per Diem",
  "Volunteer",
  "Other"
];


export const seniorityLevelTypes = [
  "Intern",
  "Entry Level",
  "Associate",
  "Mid Level",
  "Senior",
  "Lead",
  "Manager",
  "Director",
  "Vice President",
  "C-Level Executive",
  "Owner",
  "Other"
];

export const refferalTypes = [
  "ENPP",
  "Online Advertisement",
  "Social Media",
  "Friend or Family",
  "Job Fair",
  "Recruitment Agency",
  "Company Website",
  "Networking Event",
  "Professional Association",
  "Other Website",
  "Other"
];